import { RouterProvider, ScrollRestoration } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Fragment } from 'react/jsx-runtime';
import Routers from './routers/RouterProvider';
import GlobalSocketEvents from './coreComponents/GlobalSocketEvents';
import { initAnalytics } from './services/analytics';
import { useAppSelector } from './reduxToolkit/hooks';

const App = () => {
  const { role, id } = useAppSelector((state) => state.auth);
  initAnalytics({
    dest: 'https',
    endpoint: `${process.env.REACT_APP_BACKEND_API}/analytics/events`,
    userRole: role ?? null,
    user_id: id,
  });
  return (
    <Fragment>
      <GlobalSocketEvents />
      <RouterProvider router={Routers} />
      <ToastContainer newestOnTop />
   
    </Fragment>
  );
};

export default App;
